<template>
    <table class="table table-bordered table-striped">
        <thead>
        <tr>
            <th class="row-actions row-actions-4-btn">&nbsp</th>
            <th class="text-center">Date</th>
            <th class="text-center">Invoice Number</th>
            <th class="text-right">Total incl. VAT</th>
            <th class="text-right">Amount Outstanding</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(swimManagerInvoice,index) in swimManagerInvoices" v-if="swimManagerInvoices.length > 0">
            <td class="row-actions row-actions-4-btn">
                <a class="btn btn-success btn-sm" :href="invoiceOnlineUrl(swimManagerInvoice.InvoiceID)"><i class="fas fa-eye"></i>&nbsp;View</a>
                <!-- <button class="btn btn-primary btn-sm" @click="handleEdit(index, group)"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button> -->
                <a class="btn btn-info btn-sm" :href="invoicePdfUrl(swimManagerInvoice.InvoiceID)"><i class="fas fa-file-pdf"></i>&nbsp;PDF</a>
            </td>
            <td class="text-center">
                {{ swimManagerInvoice.Date != null ? dateFormat(swimManagerInvoice.Date) : '' }}
            </td>
            <td class="text-center">
                {{ swimManagerInvoice.InvoiceNumber }}
            </td>
            <td class="text-right">
                {{ currencyFormat(swimManagerInvoice.Total) }}
            </td>
            <td class="text-right">
                {{ currencyFormat(swimManagerInvoice.AmountDue) }}
            </td>
        </tr>
        <tr v-if="swimManagerInvoices.length == 0">
            <td colspan="5" align="center">
                <strong>There are no invoices to display</strong>
            </td>
        </tr>
        </tbody>
    </table>

</template>



<script>

    export default {
        data: function () {
            return {
                swimManagerInvoices: []
            }
        },
        computed: {
        },
        mounted() {
            this.debug('Swim Manager Invoices component mounted.');
            this.loadInvoices();
        },
        methods: {
            currencyFormat(value) {
                this.debug('currencyFormat');
                return value.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
            },
            dateFormat(value) {
                return moment(value).format(window.SwimManagerConfig.momentDateFormatString);
            },
            invoicePdfUrl(invoiceGUID) {
                return `/club/swimmanager/invoice/${invoiceGUID}/pdf`
            },
            invoiceOnlineUrl(invoiceGUID) {
                return `/club/swimmanager/invoice/${invoiceGUID}/view`
            },
            loadInvoices() {
                this.debug('loadInvoices()');
                axios.get(`/api/v1/swimmanager/invoices`)
                    .then(response => {
                        this.swimManagerInvoices = response.data;
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem fetching the invoices.', type: 'error'});
                        console.log(error);
                    });
            },
            debug(message) {
                console.log('SwimManagerInvoices: ' + message);
            }
        }
    }
</script>
